// #region Imports

import { Table } from '@mairistem/composants';

import FactureRecuTableOptions from '../../FactureRecuTableOptions';

// #endregion

// #region Types

interface ModalRecuTableHeaderProps {
  complete: boolean;
  produitsMontants: boolean;
  recusAnterieurs: boolean;
  resteEncaisser: boolean;
  toggleResteEncaisser: () => void;
  toggleProduitsMontants: () => void;
}

// #endregion

const ModalRecuTableHeader = (props: ModalRecuTableHeaderProps) => {
  const {
    complete,
    produitsMontants,
    recusAnterieurs,
    resteEncaisser,
    toggleResteEncaisser,
    toggleProduitsMontants,
  } = props;

  return (
    <Table.Header
      style={{
        position: 'sticky',
        top: -1,
        background: 'white',
        zIndex: 10,
      }}
    >
      <Table.Row>
        <Table.HeaderCell style={{ width: 175 }}>N° de facture</Table.HeaderCell>
        <Table.HeaderCell>Payeur</Table.HeaderCell>
        <Table.HeaderCell>Cycle de facturation</Table.HeaderCell>
        <Table.HeaderCell style={{ width: 100 }} textAlign="center">
          Date limite
        </Table.HeaderCell>
        {produitsMontants && (
          <Table.HeaderCell textAlign="center">Produits et montants</Table.HeaderCell>
        )}
        <Table.HeaderCell style={{ width: 130 }} textAlign="right">
          Montant facture
        </Table.HeaderCell>
        {recusAnterieurs && (
          <Table.HeaderCell style={{ width: 160 }} textAlign="right">
            Montant à encaisser
          </Table.HeaderCell>
        )}
        <Table.HeaderCell style={{ width: 160 }} textAlign="right">
          Montant encaissé
        </Table.HeaderCell>
        {resteEncaisser && (
          <Table.HeaderCell style={{ width: 145 }} textAlign="right">
            Reste à encaisser
          </Table.HeaderCell>
        )}
        <FactureRecuTableOptions
          onProduitMontantsClick={toggleProduitsMontants}
          produitsMontantsVisible={produitsMontants}
          {...(!complete && {
            resteEncaisserVisible: resteEncaisser,
            onResteEncaisserClick: toggleResteEncaisser,
          })}
        />
      </Table.Row>
    </Table.Header>
  );
};

export default ModalRecuTableHeader;
